<div>
  <label class="form-label fg-label" *ngIf="props.propisPlaceholder.isLabel && props.label" for="{{ props.field_Name }}">
    {{ props.label }}
    <span *ngIf="props.required && props.label">*</span>
</label>

  <!-- Datepicker -->
  <div *ngIf="props.fieldType === 'datepicker'">
    <div class="input-group">
      <input
        type="text"
        placeholder="{{
          props.isPlaceholder ? props.placeholderLabel : props.label
        }}"
        class="form-control border-right-0"
        id="{{ props.field_Name }}"
        formControlName="{{ props.field_Name }}"
        bsDatepicker
        [bsValue]="bsValue"
        [minDate]="this.props.propminDate"
        [maxDate]="this.props.propmaxDate"
        [bsConfig]="bsConfig"
        (ngModelChange)="onValueChange($event)"
        (onShown)="onOpenCalendar($event)"
        (click)="preventOpen($event)"
        [readOnly]="true"
      />
      <div
        class="input-group-append"
        *ngIf="props.propisPlaceholder.isIconVisible"
      >
        <span class="input-group-text custom-upload-icon border-left-0">
          <i class="date-icon"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- Datetimepicker -->
  <div class="input-group mr-2" *ngIf="props.fieldType === 'datetimepicker'">
    <input
      type="text"
      placeholder="{{ props.label }}"
      class="form-control"
      id="{{ props.field_Name }}"
      formControlName="{{ props.field_Name }}"
      (blur)="inputBlur($event)"
      [value]="dateString | date : props.propFormat"
      [disabled]="disabled"
      [readOnly]="this.props.readOnly"
    />
    <div class="input-group-append">
      <button
        class="btn btn-outline-secondary"
        [ngbPopover]="calendarContent"
        [disabled]="disabled"
        type="button"
      >
        <img
          src="assets/images/SuperAdmin/calendar.svg"
          style="height: 20px; width: 20px"
          alt="calendar"
        />
      </button>
    </div>
  </div>
  <sm-error [control]="formcontrol" [label]="props.label"></sm-error>

  <!-- Ngb-datepicker and Ngb-timepicker popover content -->
  <ng-template #calendarContent>
    <div>
      <div *ngIf="!showTimePickerToggle">
        <ngb-datepicker
          id="dp"
          #dp
          [ngModel]="datetime"
          [ngModelOptions]="{standalone: true}"
          name="datepicker"
          [minDate]="minDate"
          (ngModelChange)="onDateChange($event, dp)"
        ></ngb-datepicker>
        <button
          class="btn btn-block btn-outline-secondary"
          [disabled]="!datetime?.day"
          type="button"
          (click)="toggleDateTimeState($event)"
        >
          <img
            src="assets/images/SuperAdmin/clock.svg"
            style="height: 20px; width: 20px"
            alt="clock"
          />
        </button>
      </div>
      <div *ngIf="showTimePickerToggle">
        <button
          class="btn btn-block btn-outline-secondary"
          type="button"
          (click)="toggleDateTimeState($event)"
        >
          <img
            src="assets/images/SuperAdmin/calendar.svg"
            style="height: 20px; width: 20px"
            alt="calendar"
          />
        </button>
        <div class="mt-auto">
          <ngb-timepicker
            #tp
            name="timepicker"
            [ngModel]="datetime"
            (ngModelChange)="onTimeChange($event)"
            [ngModelOptions]="{standalone: true}"
            [hourStep]="hourStep"
            [minuteStep]="minuteStep"
            [meridian]="meridian"
          >
          </ngb-timepicker>
        </div>
      </div>
    </div>
  </ng-template>
</div>
